import { useEffect, useState } from "react";

export function useAnimationTrigger(className: string) {
    const [isActive, setIsActive] = useState(false);

    function trigger() {
        // Reset so we can retrigger
        setIsActive(false);

        // Delay so that it can process
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setIsActive(true);
            });
        });
    }

    return {
        className: isActive ? className : "",
        trigger,
    };
}